import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { appConfig } from "../../apiConfig";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const primary = "var(--color-primary-500)"

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white/95 backdrop-blur-xl shadow-lg border-b border-gray-100" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 ">
        <div className="flex items-center justify-between h-16 lg:h-20">
          
          <Link to="/" className="flex items-center group mb-2">
            <div className="relative max-xl:hidden">
              <img src={`/images/${appConfig.slug}-logo.png`}  height={80} width={appConfig.slug === 'nextlead' ? 150 : 120} alt="logo" />
            </div>

            {/* Mobile / smaller screens */}
            <div className="relative xl:hidden mr-2">
              <img src={`/images/${appConfig.slug}-logo.png`}  height={90} width={appConfig.slug === 'nextlead' ? 150 : 120} alt="logo" />
            </div>
          </Link>


          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-reverse text-[15px]">
            <Link
              to="/"
              className='relative text-gray-700 px-4 py-2 font-medium transition-all duration-300 group'
              style={{ cursor: "pointer" }}
            >
              الرئيسية
              <span
                className="absolute bottom-0 right-0 w-0 h-0.5 group-hover:w-full transition-all duration-300"
                style={{ backgroundColor: primary }}
              />
              <style >{`
                Link:hover {
                  color: ${primary} !important;
                }
              `}</style>
            </Link>

            <Link
              to="/about"
              className='relative text-gray-700 px-4 py-2 font-medium transition-all duration-300 group'
              style={{ cursor: "pointer" }}
            >
              من نحن
              <span
                className="absolute bottom-0 right-0 w-0 h-0.5 group-hover:w-full transition-all duration-300"
                style={{ backgroundColor: primary }}
              />
              <style >{`
                Link:hover {
                  color: ${primary} !important;
                }
              `}</style>
            </Link>

            <Link
              to="/#how-it-work"
              className='relative text-gray-700 px-4 py-2 font-medium transition-all duration-300 group'
              style={{ cursor: "pointer" }}
            >
              كيف تعمل منصتنا؟
              <span
                className="absolute bottom-0 right-0 w-0 h-0.5 group-hover:w-full transition-all duration-300"
                style={{ backgroundColor: primary }}
              />
              <style >{`
                Link:hover {
                  color: ${primary} !important;
                }
              `}</style>
            </Link>

            <Link
              to="/contact"
              className='relative text-gray-700 px-4 py-2 font-medium transition-all duration-300 group'
              style={{ cursor: "pointer" }}
            >
              اتصل بنا
              <span
                className="absolute bottom-0 right-0 w-0 h-0.5 group-hover:w-full transition-all duration-300"
                style={{ backgroundColor: primary }}
              />
              <style >{`
                Link:hover {
                  color: ${primary} !important;
                }
              `}</style>
            </Link>

            <Link
              to="/policy"
              className='relative text-gray-700 px-4 py-2 font-medium transition-all duration-300 group'
              style={{ cursor: "pointer" }}
            >
              سياسة الخصوصية
              <span
                className="absolute bottom-0 right-0 w-0 h-0.5 group-hover:w-full transition-all duration-300"
                style={{ backgroundColor: primary }}
              />
              <style >{`
                Link:hover {
                  color: ${primary} !important;
                }
              `}</style>
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <div
              to="/login"
              className="relative px-6 py-1.5 text-white font-semibold rounded-full overflow-hidden group hover:shadow-2xl transition-all duration-300"
              style={{
                background: `linear-gradient(90deg, ${primary} 20%, var(--color-primary-400) 100%)`,
                boxShadow: `0 0 15px ${primary}80`,
              }}
            >
              <Link to="/login">
              <span className="relative z-10 text-xs">تسجيل الدخول</span>
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: `linear-gradient(90deg, var(--color-primary-400)), var(--color-primary-500))` }}
                />
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className='inline-flex text-gray-700 items-center justify-center p-2 rounded-xl hover:bg-gray-100 transition-all duration-200'
              // style={{ color: isScrolled ? primary : "white" }}
            >
              {isMenuOpen ? (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-xl border-t border-gray-100">
          <div className="px-4 pt-4 pb-6 space-y-3">
            <Link
              to="/"
              className="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-[var(--color-primary-500)] hover:bg-[var(--color-primary-50)] transition-all duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              الرئيسية
            </Link>
            <Link
              to="/about"
              className="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-[var(--color-primary-500)] hover:bg-[var(--color-primary-50)] transition-all duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              من نحن
            </Link>
            <Link
              to="/products"
              className="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-[var(--color-primary-500)] hover:bg-[var(--color-primary-50)] transition-all duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              المنتجات
            </Link>
            <Link
              to="/contact"
              className="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-[var(--color-primary-500)] hover:bg-[var(--color-primary-50)] transition-all duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              اتصل بنا
            </Link>
            <Link
              to="/policy"
              className="block px-4 py-3 rounded-xl text-base font-medium text-gray-700 hover:text-[var(--color-primary-500)] hover:bg-[var(--color-primary-50)] transition-all duration-200"
              onClick={() => setIsMenuOpen(false)}
            >
              سياسة الخصوصية
            </Link>
            <div className="pt-4">
              <Link to="/login">
              <button
                className="w-full px-8 py-3 text-white font-semibold rounded-full hover:shadow-lg transition-all duration-300"
                style={{
                  background: `linear-gradient(90deg, var(--color-primary-500) 40%, var(--color-primary-400) 80%)`,
                  boxShadow: `0 0 15px ${primary}80`,
                }}
              >
              تسجيل الدخول
              </button>
                </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}